import { createFileRoute } from '@tanstack/react-router'
import { StaffKetertiban } from '../../../../components/StaffKetertiban'

export const Route = createFileRoute('/platform/desa/$desaId/ketertiban')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffKetertiban desaId={desaId} />
  },
})
